import {
  Spacer,
  TagDeleteIcon,
  TagLabel,
  Tooltip,
  Typography,
} from "@aircall/tractor";
import { useParams } from "react-router";

import { useLinkTagsToCall } from "@/hooks/useLinkToTags/useLinkTagsToCall";
import { RouteParams } from "../Transcription/Transcription.decl";

import { MAX_LENGTH } from "./TagsListItem.constants";
import { TagsListItemProps } from "./TagsListItem.decl";

import { TagBeautified } from "@/components/TagBeautified";
import { trimWithEllipsis } from "@/helpers/string/string.helpers";
import { useBaseStore } from "@/store/store";
import { useTracking } from "./TagsListItem.hooks";

export function TagsListItem({ color, name, id }: TagsListItemProps) {
  const { callId } = useParams<RouteParams>();
  const { onClick: handleOnClickTrack } = useTracking();

  const tagIds = useBaseStore((state) => state.tagIds);
  const setTagIds = useBaseStore((state) => state.setTagIds);

  const { updateTags } = useLinkTagsToCall({ callId: callId! });

  const handleOnClick = () => {
    const filtered = tagIds.filter((tagId) => tagId !== id);

    handleOnClickTrack();
    updateTags(filtered);
    setTagIds(filtered);
  };

  if (!name) {
    return null;
  }

  if (name.length > MAX_LENGTH) {
    return (
      <Tooltip
        align="center"
        mouseEnterDelay={0}
        mouseLeaveDelay={100}
        side="top"
        title={name}
      >
        <TagBeautified color={color} data-test={`tags-list-item-${name}`}>
          <TagLabel>
            <Spacer space="xxxs" direction="horizontal" alignItems="center">
              <Typography variant="supportingMediumS">
                {trimWithEllipsis(name, MAX_LENGTH)}
              </Typography>
              <TagDeleteIcon
                data-test={`tags-list-item-delete-${name}`}
                onClick={handleOnClick}
              />
            </Spacer>
          </TagLabel>
        </TagBeautified>
      </Tooltip>
    );
  }

  return (
    <TagBeautified color={color} data-test={`tags-list-item-${name}`}>
      <TagLabel>
        <Spacer space="xxxs" direction="horizontal" alignItems="center">
          <Typography variant="supportingMediumS">
            {trimWithEllipsis(name, MAX_LENGTH)}
          </Typography>
          <TagDeleteIcon
            data-test={`tags-list-item-delete-${name}`}
            onClick={handleOnClick}
          />
        </Spacer>
      </TagLabel>
    </TagBeautified>
  );
}
